<template>
    <div>

        <v-dialog
            v-model="purgeLoading"
            max-width="400"
            persistent
        >
            <v-card>
                <v-toolbar dense>
                    <v-toolbar-title>Vérfication</v-toolbar-title>
                    <v-progress-linear
                        active
                        indeterminate
                        absolute
                        bottom
                        color="teal"
                    ></v-progress-linear>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid>
                        <div class="text-center">
                            En Cours de Vérification .....
                        </div>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-toolbar class="elevation-5 mb-2" flat color="white" dense height="40">
            <v-toolbar-title class="title">
                {{ category === 'FILTER' ? $t('module.notification') : $t('module.issue') }}
                <v-chip label larger dark color="blue darken-2">{{ total }}</v-chip>
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <div class="flex-grow-1"></div>
        </v-toolbar>

        <v-container fluid v-if="items.length === 0">
            <v-alert
                text
                dense
                color="teal"
                icon="mdi-clock-fast"
                border="left"
            >
                <span v-if="category === 'FILTER'">
                    Votre espace de notifications est actuellement vide.
                    Activez vos préférences de notifications <br/> pour rester informé(e)
                    et profitez pleinement de votre expérience sur la plateforme !
                </span>
                <span v-if="category === 'ISSUE'">
                    Votre système fonctionne normalement, sans aucune anomalie enregistrée.
                    Assurez-vous que vos paramètres de surveillance<br/> sont activés pour rester informé(e)
                    de tout changement ou activité inhabituelle.
                </span>
            </v-alert>
        </v-container>
        <v-container fluid v-else>
            <template v-for="(m, index) in availableModules">
                <v-row dense :key="m">
                    <template v-for="item in items">
                        <v-col
                            cols="12"
                            md="6"
                            :key="item.idControlProgram"
                            v-if="item.module === m"

                        >
                            <v-card elevation="10">
                                <v-toolbar height="40" color="orange darken-2" class="elevation-5 mb-2">
                                    <v-toolbar-title class="white--text">{{ item.title }}</v-toolbar-title>
                                    <v-spacer/>
                                    <v-chip
                                        small
                                        color="red"
                                        dark
                                    >
                                        <strong>{{ item.details.length }}</strong>
                                    </v-chip>
                                    <v-btn
                                        class="white--text"
                                        icon
                                        @click="selectProgram(item)"
                                    >
                                        <v-icon>mdi-open-in-new</v-icon>
                                    </v-btn>
                                </v-toolbar>
                                <v-simple-table dense fixed-header height="300">
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th class="text-left">Code</th>
                                            <th class="text-left">Nom</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr
                                            v-for="(detail, index) in item.details"
                                            :key="`${m}-detail-${index}`"
                                            @dblclick="openDetail(detail, m)"
                                        >
                                            <td>
                                                <v-chip small label color="teal" dark class="ma-1">
                                                    <strong>{{ detail.code }}</strong>
                                                </v-chip>
                                            </td>
                                            <td>
                                                <v-chip small label color="blue" dark class="ma-1">
                                                    <strong>{{ detail.name }}</strong>
                                                </v-chip>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </template>
                </v-row>
                <v-divider
                    v-if="index < 1"
                    :key="`d-${m}`"
                    class="mt-10 mb-10"
                />
            </template>
        </v-container>

        <router-view/>
    </div>
</template>
<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import {computed, onMounted, ref} from "vue";
import {useSecurityStore} from "@/stores/Security";
import {storeToRefs} from "pinia";
import axios from "axios";

export default {
    name: "ListingModel",
    props: {
        category: String,
    },
    setup(props) {
        const {$router} = useTools();
        const {loading, total} = useSharedData();
        const items = ref([]);
        const securityStore = useSecurityStore();
        const {idControlProgram, idIssue} = storeToRefs(securityStore);

        const availableModules = computed(() => {
            const modules = []
            if (securityStore.authorities['READ_WORKER']) modules.push('worker')
            if (securityStore.authorities['READ_CONTRAT']) modules.push('contrat')
            return modules
        });

        function findAll() {
            loading.value = true;
            axios.get('/notificationRecords', {params: {withDetail: true}}).then(response => {
                if (availableModules.value.length > 0) {
                    items.value = response.data.elements;
                    total.value = response.data.total;
                }
            }).finally(() => {
                loading.value = false;
            });
        }

        function getIssues() {
            loading.value = true;
            axios.get('/notificationRecords/issues').then(response => {
                if (availableModules.value.length > 0) {
                    items.value = response.data.elements;
                    total.value = response.data.total;
                }
            }).finally(() => {
                loading.value = false;
            });
        }


        const purgeLoading = ref(false);

        function purgeAndAddNewNotificationRecord() {
            // purgeLoading.value = true;
            axios.put('/alarms/purgeAndAddNewNotificationRecord').then(() => {
                findAll();
            }).finally(() => {
                purgeLoading.value = false;
            });
        }

        function selectProgram(item) {

            if (props.category === 'FILTER') {
                securityStore.setIssue(null, item.module);
                securityStore.setControlProgram(item.idControlProgram, item.module);
            } else if (props.category === 'ISSUE') {
                securityStore.setControlProgram(null, item.module);
                securityStore.setIssue(item.idControlProgram, item.module);
            }

            let route;
            switch (item.module) {
                case 'worker':
                    route = 'workers';
                    break;
                case 'contrat':
                    route = 'contrats';
                    break;
            }
            $router.push({name: route}).catch(() => {
            });
        }

        const parentPath = computed(() => props.category === 'FILTER' ? 'notifications' : 'issues')

        function openDetail(detail, module) {
            switch (module) {
                case 'worker':
                    $router.push({name: `${parentPath.value}.workers.view`, params: {id: detail.idEntity, backPath: parentPath.value}})
                    break;
                case 'contrat':
                    $router.push({name: `${parentPath.value}.contrats.view`, params: {id: detail.idEntity}})
                    break;
            }
        }

        onMounted(() => {
            if (props.category === 'FILTER') {
                purgeAndAddNewNotificationRecord();
            } else if (props.category === 'ISSUE') {
                getIssues();
            }
        });

        return {
            loading,
            purgeLoading,
            total,
            items,
            idControlProgram,
            idIssue,
            availableModules,
            findAll,
            purgeAndAddNewNotificationRecord,
            selectProgram,
            openDetail,
        }
    }
}
</script>

<style scoped>

</style>